export default "__VITE_ASSET__f68e29a1__"